import { render, staticRenderFns } from "./CurrentFilterList.vue?vue&type=template&id=f8c9999a&"
import script from "./CurrentFilterList.vue?vue&type=script&lang=js&"
export * from "./CurrentFilterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports